import { SalaryAdvanceSettingsPageDocument } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

import { ResponsivePage } from 'modules/layout/components/ResponsivePage'
import CapPercentageSetting from 'modules/salary_advance/pages/settings/Content/CapPercentageSetting'
import ClosureDaySetting from 'modules/salary_advance/pages/settings/Content/ClosureDaySetting'
import ServiceEnablementSetting from 'modules/salary_advance/pages/settings/Content/ServiceEnablementSetting'

const SalaryAdvanceSettingsPage = () => {
  const { data, loading, error } = useQuery(SalaryAdvanceSettingsPageDocument)

  const companySetting = data?.salaryAdvance?.companySettingsConnection?.nodes?.[0]
  const canEdit = data?.salaryAdvance?._policies?.manageSalaryAdvance?.can ?? false
  // non-null value is expected from the backend
  const advanceCapMonthlyWagePercent = companySetting?.advanceCapMonthlyWagePercent
  // is required and always has a value
  const requestDeadlineDay = companySetting?.requestDeadlineDay
  // service enablement toggle
  const serviceEnabled = companySetting?.serviceEnabled ?? false

  if (!companySetting || requestDeadlineDay == null || advanceCapMonthlyWagePercent == null) {
    return (
      <ResponsivePage.Body loading={loading} error={error}>
        {null}
      </ResponsivePage.Body>
    )
  }

  return (
    <ResponsivePage.Body>
      <ServiceEnablementSetting
        serviceEnabled={serviceEnabled}
        requestDeadlineDay={requestDeadlineDay}
        advanceCapMonthlyWagePercent={advanceCapMonthlyWagePercent}
        canEdit={canEdit}
      />
      <CapPercentageSetting
        currentCapPercentage={advanceCapMonthlyWagePercent}
        requestDeadlineDay={requestDeadlineDay}
        serviceEnabled={serviceEnabled}
        canEdit={canEdit}
      />
      <ClosureDaySetting
        requestDeadlineDay={requestDeadlineDay}
        serviceEnabled={serviceEnabled}
        advanceCapMonthlyWagePercent={advanceCapMonthlyWagePercent}
        canEdit={canEdit}
      />
    </ResponsivePage.Body>
  )
}

export default SalaryAdvanceSettingsPage
